<div>
  <button nz-button nzType="dashed" [nzSize]="'large'" (click)="goBack()">
    <nz-icon nzType="left" nzTheme="outline"/>
  </button>
</div>
<nz-divider nzText="Create Organizations"></nz-divider>

<div class="max-w-96 m-auto">
  <form nz-form [formGroup]="validateForm" class="login-form" (ngSubmit)="submitForm()">
    <nz-form-item>
      <nz-form-label nzRequired nzFor="name">Name</nz-form-label>
      <nz-form-control nzErrorTip="Please input Organization name!">
        <nz-input-group nzPrefixIcon="user">
          <input type="text" nz-input formControlName="name" placeholder="name"/>
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label nzRequired nzFor="email">E-mail</nz-form-label>
      <nz-form-control nzErrorTip="Please enter Organization email!">
        <nz-input-group nzPrefixIcon="mail">
          <input type="email" nz-input formControlName="email" placeholder="email"/>
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzRequired nzFor="phone">Phone</nz-form-label>
      <nz-form-control nzErrorTip="Please enter Organization phone!">
        <nz-input-group nzPrefixIcon="phone">
          <input type="text" nz-input formControlName="phone" placeholder="phone"/>
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzRequired nzFor="address">Address</nz-form-label>
      <nz-form-control nzErrorTip="Please enter Organization address!">
        <nz-input-group nzPrefixIcon="home">
          <input type="text" nz-input formControlName="address" placeholder="address"/>
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzRequired nzFor="website">Website</nz-form-label>
      <nz-form-control nzErrorTip="Please enter Organization website!">
        <nz-input-group nzPrefixIcon="link">
          <input type="text" nz-input formControlName="website" placeholder="website"/>
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>
    <button nz-button class="login-form-button login-form-margin w-full" [nzType]="'primary'" [nzSize]="'large'">
      Create
    </button>
  </form>
</div>
